import { createSlice } from '@reduxjs/toolkit';

// Define a type for the slice state
interface IChassisManagerState {
    data: Array<IChassisManager> | null;
    pageSize: number;
    pageNumber: number;
    totalCount: number;
    showLoading: ILoading;
    isLoading: boolean;
    isSuccess: boolean;
    details: IChassisManager | null;
}

// Define the initial state using that type
const initialState: IChassisManagerState = {
    data: null,
    pageSize: 0,
    pageNumber: 0,
    totalCount: 0,
    showLoading: {
        sourceAction: '',
        state: false,
    },
    isLoading: false,
    isSuccess: false,
    details: null
};

export const chassisManagerSlice = createSlice({
    name: 'chassisManager',
    // `createSlice` will infer the state type from the `initialState` argument
    initialState,
    reducers: {
        setLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: action.payload.sourceAction,
                state: true,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        resetLoading: (state, action) => {
            const { isLoading, isSuccess } = action.payload;
            state.showLoading = {
                sourceAction: '',
                state: false,
            };
            state.isLoading = isLoading ? isLoading : false;
            state.isSuccess = isSuccess ? isSuccess : false;
        },
        replaceChassisManager: (state, action) => {
            const { data, pageSize, pageNumber, totalCount } = action.payload;
            state.data = data;
            state.pageSize = pageSize;
            state.pageNumber = pageNumber;
            state.totalCount = totalCount;
        },
        addChassisManager: (state, action) => {
            const newItem = action.payload.data;
            if (state.data && state.data.length > state.pageSize) {
                state.data.pop();
            }
            state.data = state.data ? [newItem, ...state.data] : [newItem];
            state.totalCount = state.totalCount + 1;
        },
        updateChassisManager: (state, action) => {
            const { localID, data } = action.payload;
            if (localID !== undefined && localID >= 0 && state.data) {
              state.data[localID] = data;
            }
            state.details = data;
          },
        deleteChassisManager: (state, action) => {
            const chassisManagerToRemove: IChassisManager = action.payload.data;
            const newChassisManagerData = state.data && state.data.filter(
                (chassisManager: IChassisManager) => {
                    return (
                        chassisManager.id !== chassisManagerToRemove.id
                    );
                }
            );
            state.data = newChassisManagerData;
            state.totalCount = state.totalCount - 1;
        },
        setChassisManagerDetails: (state, action) => {
            state.details = action.payload.data;
        }
    },
});

export const chassisManagerActions = chassisManagerSlice.actions;

export default chassisManagerSlice.reducer;
